import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormX from 'sb-formx'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, compose, links } from 'common/helpers'
import { required } from 'helpers/validation'
import cx from 'classnames'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import Field from 'components/_new/forms/Field/Field'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'
import Picture from 'components/ui/Picture/Picture'

import SelectRating from '../SelectRating/SelectRating'
import AgeSelect from './AgeSelect/AgeSelect'

import s from './IncubatorReviewEditModal.scss'
import messages from './messages'


const form = new FormX({
  name: 'ReviewForm',
  fields: {
    text: [ required ],
    rating: [ required ],
    userAge: [],
  },
})

class IncubatorReviewEditModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.review.IncubatorReviewEdit,
    data: {
      userReview: {},
    },
  }

  componentDidMount() {
    const { updateFieldValues, data: { userReview: { rating, text, userAge } } } = this.props

    updateFieldValues({ rating, text, userAge })
  }

  componentWillUnmount() {
    form.unsetValues()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  handleSubmit = () => {
    const { data: { userReview: { id: reviewId }, onReviewEdited } } = this.props

    form.submit()
      .then((values) => {
        actions.view.incubatorPage.editReview({
          review: values,
          reviewId,
        })
          .then(() => {
            if (typeof onReviewEdited === 'function') {
              onReviewEdited()
            }

            this.close()
          })
      })
  }

  renderHeading() {
    const { data: { userReview, title, image } } = this.props

    const headingClassName = cx({
      [s.headingEdit]: Boolean(userReview),
    })

    return (
      <div className={headingClassName}>
        {
          Boolean(image) && (
            <Picture className={s.previewImage} {...image} alt="Fragrance preview" />
          )
        }
        <FormattedMessage className={s.title} tag="div" values={{ title }} {...messages.title} />
        <FormattedHTMLMessage tag="div" {...messages.description} />
      </div>
    )
  }

  renderForm() {
    const { isNeonConceptPage } = this.props

    return (
      <div className={s.form}>
        <SelectRating
          withNumbers
          count={isNeonConceptPage ? 10 : 5}
          field={form.fields.rating}
        />
        <Field
          className={s.formItem}
          field={form.fields.text}
          label={messages.reviewPlaceholder}
          placeholder={messages.reviewDescription}
          standardView
          rows={9}
        />
        <div className={s.actions}>
          {
            isNeonConceptPage && (
              <AgeSelect field={form.fields.userAge} />
            )
          }
          <div className={s.buttons}>
            <CommonButton
              className={s.backButton}
              xlg
              cancel
              emptyGray
              onClick={this.close}
            />
            <Button
              className={s.submitButton}
              xlg
              brand
              onClick={this.handleSubmit}
              title={messages.save}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        className={s.modal}
        name={name}
      >
        {this.renderHeading()}
        {this.renderForm()}
      </Modal>
    )
  }
}


export default compose(
  connect({
    product: 'models.review.product',
    isNeonConceptPage: (state) => state.routing.location.pathname === links.incubator.neonHeat,
  }),
)(IncubatorReviewEditModal)
